import { v4 as uuidv4 } from 'uuid';

import { readCookie } from '@zapier/cookies';

import { EVENT_TYPE, SYSTEM_NAME } from './constants';
import { emit } from './utils';

const TYPE = EVENT_TYPE.USER_INTERACTION;

type UserInteractionEvent = {
  absolute_url: string;
  destination_url_address?: string;
  event_action: 'click' | 'select' | 'in_view' | 'deselect';
  event_id: string;
  identity_id: string;
  interaction_goal?: string;
  interaction_name: string;
  interaction_raw_text?: string;
  option_selected: string;
  release_id: string;
  system_name: typeof SYSTEM_NAME;
  timestamp_ms: number;
  visitor_id: string;
};

function emitUserInteractionEvent(eventProperties: {
  destinationUrlAddress?: string;
  eventAction: 'click' | 'select' | 'in_view' | 'deselect';
  integrationId?: number;
  integrationVersion?: string;
  interactionGoal?: string;
  interactionName: string;
  interactionRawText?: string;
  optionSelected?: string;
  userId: number;
}) {
  const properties: UserInteractionEvent = {
    absolute_url: location.href,
    event_action: eventProperties.eventAction,
    event_id: uuidv4(),
    identity_id: readCookie('zapidentity'),
    interaction_name: eventProperties.interactionName,
    option_selected: eventProperties.optionSelected ?? 'not_applicable',
    release_id: process.env.COMMIT_HASH,
    system_name: SYSTEM_NAME,
    timestamp_ms: Date.now(),
    visitor_id: readCookie('visitor_id'),
  };
  if (eventProperties.destinationUrlAddress) {
    properties.destination_url_address = eventProperties.destinationUrlAddress;
  }
  if (eventProperties.interactionGoal) {
    properties.interaction_goal = eventProperties.interactionGoal;
  }
  if (eventProperties.interactionRawText) {
    properties.interaction_raw_text = eventProperties.interactionRawText;
  }

  emit(properties, TYPE);
}

export default emitUserInteractionEvent;
